import React from 'react';
import { profile } from '../data';

function About() {
  return (
    <section className="section" id="about">
      <div className="section-head reveal">
        <span className="eyebrow">
          <i className="fa-solid fa-user"></i> About me
        </span>
        <h2 className="section-title">
          From the shop floor to <span className="gradient-text">shipping software</span>
        </h2>
        <p className="section-sub">
          A career switcher who turned curiosity into a craft.
        </p>
      </div>

      <div className="about-grid">
        <div className="about-card card reveal">
          <p>
            I discovered my passion for software while working in the mechanical
            industry. That curiosity pushed me to skill up as a developer — first
            through online courses, then a full-time MERN-stack program at 10x
            Academy, which I genuinely loved.
          </p>
          <p>
            Today I work at Octalogic Tech, focused mainly on the backend —
            building APIs and services with NestJS, Node.js and PostgreSQL, and
            deploying them with Docker, Kubernetes and AWS. I also take on
            freelance client work in my spare time. I care about clean, reliable
            code and systems that hold up in production.
          </p>
          <p>
            I'm always eager to grow with a collaborative team where I can
            contribute fully and keep sharpening my skills.
          </p>
        </div>

        <div className="about-facts">
          <div className="fact card reveal">
            <i className="fa-solid fa-briefcase"></i>
            <div>
              <div className="fact-label">Currently</div>
              <div className="fact-value">Backend Developer @ Octalogic Tech</div>
            </div>
          </div>
          <div className="fact card reveal">
            <i className="fa-solid fa-location-dot"></i>
            <div>
              <div className="fact-label">Based in</div>
              <div className="fact-value">{profile.location}</div>
            </div>
          </div>
          <div className="fact card reveal">
            <i className="fa-solid fa-laptop-code"></i>
            <div>
              <div className="fact-label">Focus</div>
              <div className="fact-value">NestJS · PostgreSQL · AWS</div>
            </div>
          </div>
          <div className="fact card reveal">
            <i className="fa-solid fa-handshake"></i>
            <div>
              <div className="fact-label">Open to</div>
              <div className="fact-value">Freelance &amp; full-time roles</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
